module.exports = __webpack_public_path__ + "static/media/creamyrisotto.3661ce27.jpg";